import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import {
  AppBar,
  Toolbar,
  Container,
  Typography,
  Button, Grid,
} from '@material-ui/core';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Comment } from '@material-ui/icons';
import { reduxForm, getFormValues } from 'redux-form';
import { isSupported, sign } from 'u2f-api';
import styles from '../../assets/jss/NewLoginScreenStyles';
import CTextField from '../Utils/CTextField';
import {
  requestForSmsSendAtLogin,
  verifySmsAtLogin,
  verify2FAToken,
  requestAtLogin,
  verificationAtLogin,
} from '../../actions';
import CustomMessages from './CustomMessages';
import lmLogo from '../../assets/images/update_portal_login.png';
import dmLogo from '../../assets/images/up-login-dm-logo.png';
import U2fInserstDeviceModal from '../User/AuthorisationModals/U2fInsertDeviceModal';
import { AuthService, EncryptionServices } from '../../services';
import headerLogo from '../../assets/images/logo-revbits.png';
import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';

// eslint-disable-next-line no-unused-vars
const onSubmit = async (values, dispatch, props) => {
};

class OTPScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: {
        otp: '',
        sms: '',
        recoveryCode: '',
      },
      isError: false,
      timer: 60,
      smsSent: false,
      isValidOtp: false,
      otpKey: Math.random() * 100,
      showDeviceList: false,
      isU2FModelOpen: false,
    };
    this.timerInterval = '';
    this.url = '';
    // this.activeMethod = null;
    this.deviceList = 0;
    this.token = JSON.parse(sessionStorage.getItem('cred'))?.token;
  }

  componentDidMount() {
    if (this.url === 'verify-sms') this.verifySentSms(); // function call
    if (this.url === 'verify-securityKey') {
      EncryptionServices.decodeJwtToken(this.token).then((decryptToken) => {
        this.deviceList = decryptToken.deviceList;
        this.validateU2F();
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  handleIsU2FModel = () => {
    const { isU2FModelOpen } = this.state;

    this.setState({ isU2FModelOpen: !isU2FModelOpen });
  };

  /**
   * handleCloseRequired is for hidding the error border
   * @param elementDom
   */
  static handleCloseRequired = (elementDom) => {
    elementDom.classList.remove('warning');
  };

  /**
   * verifySentSms sent sms on the registered mobile number
   */
  verifySentSms = () => {
    const { history } = this.props;
    const { isError } = this.state;
    requestForSmsSendAtLogin({ token: this.token }).then((res) => {
      if (res.status === 200) {
        const { inputValue } = this.state;
        inputValue.sms = null;
        clearInterval(this.timerInterval);
        this.setState({
          timer: 60,
          inputValue,
          smsSent: true,
        });
        this.setTimer();
        return;
      } if (res.data) {
        if (typeof (res.data.response.errors) === 'string') {
          history.state = {
            status: 'error',
            msg: `API.${res.data.response.errors}`,
            show: true,
          };
          this.setState({ isError: !isError });
          return;
        }
        res.data.response.errors.forEach((data) => {
          history.state = {
            status: 'error',
            msg: `API.${data.msg}`,
            show: true,
          };
          this.setState({ isError: !isError });
        });
      }
    });
  };

  /**
   * handleSmsSubmit validate sms otp
   *  @param event
   */
  handleSmsSubmit = (event) => {
    event.preventDefault();

    const { inputValue, isError } = this.state;
    const { getPermission, history } = this.props;

    verifySmsAtLogin({
      smsOtp: inputValue.sms,
      token: this.token,
    }).then((res) => {
      this.clearState();
      if (res.userData) {
        sessionStorage.setItem('cred', JSON.stringify(res));
        AuthService.authenticate(res.token);
        getPermission();
        history.push('/');
      } else if (typeof (res.response.errors) === 'string') {
        this.clearState();
        history.state = {
          status: 'error',
          msg: `API.${res.response.errors}`,
          show: true,
        };
        this.setState({
          isError: !isError,
          isValidOtp: false,
        });
      } else {
        res.response.errors.forEach((data) => {
          this.clearState();
          history.state = {
            status: 'error',
            msg: `API.${data.msg}`,
            show: true,
          };
          this.setState({
            isError: !isError,
            isValidOtp: false,
          });
        });
      }
    }).catch(() => {
      this.clearState();
      history.state = {
        status: 'error',
        msg: 'TOASTER.INVALID_OTP',
        show: true,
      };
      this.setState({
        isError: !isError,
        isValidOtp: false,
      });
    });
  };

  /**
   * handleOtpSubmit validate 2fa otp
   *  @param event
   */
  handleOtpSubmit = (event) => {
    event.preventDefault();

    const { inputValue } = this.state;

    const credential = {
      challengeToken: this.token,
      otp: inputValue.otp,
    };
    this.submitOTPLogin(credential);
  };

  submitOTPLogin = (credential) => {
    this.clearState();

    const { getPermission, history } = this.props;
    const { isError } = this.state;
    verify2FAToken(credential).then((result) => {
      if (result && result.response && result.response.userData && result.status === 200) {
        sessionStorage.setItem('cred', JSON.stringify(result.response));
        AuthService.authenticate(result.response.token);
        getPermission();
        history.push('/');
      } else {
        this.clearState();
        history.state = {
          status: 'error',
          msg: 'TOASTER.2FA_VERIFY_FAIL',
          show: true,
        };
        this.setState({
          isError: !isError,
          isValidOtp: false,
        });
      }
    })
      .catch(() => {
        this.clearState();
        history.state = {
          status: 'error',
          msg: 'TOASTER.2FA_VERIFY_FAIL',
          show: true,
        };
        this.setState({
          isError: !isError,
          isValidOtp: false,
        });
      });
  };

  /**
   * handleSmsSubmit validate recoveryCode otp
   *  @param event
   */

  handleRecoveryCodeSubmit = (event) => {
    event.preventDefault();

    const { inputValue } = this.state;

    const recoverCodeCredential = {
      challengeToken: this.token,
      recovery: inputValue.recoveryCode,
    };

    this.submitRecoverCodeLogin(recoverCodeCredential);
  };

  submitRecoverCodeLogin = (recoverCodeCredential) => {
    this.clearState();

    const { getPermission, history } = this.props;
    const { isError } = this.state;

    verify2FAToken(recoverCodeCredential)
      .then((data) => {
        if (data && data.response && data.response.userData && data.status === 200) {
          sessionStorage.setItem('cred', JSON.stringify(data.response));
          AuthService.authenticate(data.response.token);
          getPermission();
          history.push('/');
        } else {
          this.clearState();
          history.state = {
            status: 'error',
            msg: 'TOASTER.RECOVERY_CODE_VERIFY_FAIL',
            show: true,
          };
          this.setState({
            isError: !isError,
            isValidOtp: false,
          });
        }
      })
      .catch(() => {
        this.clearState();
        history.state = {
          status: 'error',
          msg: 'TOASTER.RECOVERY_CODE_VERIFY_FAIL',
          show: true,
        };
        this.setState({
          isError: !isError,
          isValidOtp: false,
        });
      });
  };

  setTimer = () => {
    let time = 60;
    if (time >= 0) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      time -= 1;
      if (time >= 0) {
        this.setState({ timer: time });
      }
    }, 1000);
  };

  clearState = () => {
    this.setState({
      inputValue: {
        otp: null,
        sms: null,
        recoveryCode: null,
      },
      otpKey: Math.random() * 100,
    });
  };

  inputValue = (classes) => {
    const {
      isValidOtp, smsSent, timer, showDeviceList,
    } = this.state;

    let title;
    let button;

    let object = {
      name: 'otp',
      label: 'Verification code',
      validateForm: {
        check: true,
        message: 'VALIDATION.2FA_RANGE',
        field: 'otp',
      },
      removeErr: OTPScreen.handleCloseRequired,
    };

    switch (this.url) {
      case 'otp':
        object = {
          name: 'otp',
          label: 'Verification code',
          validateForm: {
            check: true,
            message: 'VALIDATION.2FA_RANGE',
            field: 'otp',
          },
          removeErr: OTPScreen.handleCloseRequired,
        };

        title = (
          <>
            <h2>Verify through OTP</h2>
            <p>Please enter the verification code generated from the OTP application.</p>
          </>
        );

        button = (
          <div className={classes.alignResendButton}>
            <Button
              type="submit"
              className={classes.activeButton}
              disabled={!isValidOtp}
              onClick={this.handleOtpSubmit}
            >
              <Trans>BUTTON.VERIFY</Trans>
            </Button>
          </div>
        );

        break;

      case 'verify-sms':

        object = {
          name: 'sms',
          label: 'Verification code',
          validateForm: {
            check: true,
            message: 'VALIDATION.2FA_RANGE',
            field: 'sms',
          },
          removeErr: OTPScreen.handleCloseRequired,
        };

        title = (
          <>
            <h2>Verify through SMS</h2>
            <p>Send a verification code to your phone number</p>
          </>
        );

        button = (
          <div className={classes.alignResendButton}>
            <Button
              type="submit"
              className={classes.activeButton}
              disabled={!(smsSent && isValidOtp)}
              onClick={this.handleSmsSubmit}
            >
              <Trans>BUTTON.VERIFY</Trans>
            </Button>

            <Button
              type="button"
              className={`${classes.activeButton} ${classes.mailButton} ${classes.commentIconSvg}`}
              disabled={(timer > 0)}
              onClick={this.verifySentSms}
            >
              <Comment />
              {timer === 0 ? <Trans>SETTINGS.RESEND_SMS</Trans> : (
                <>
                  <Trans>SETTINGS.RESEND_SMS</Trans>
                  <p
                    className="timer"
                  >
                    (
                    {timer}
                    )
                  </p>
                </>
              )}
            </Button>

          </div>
        );

        break;

      case 'verify-recoveryCode':

        object = {
          name: 'recoveryCode',
          label: 'Enter Code',
          validateForm: {
            check: true,
            message: 'VALIDATION.2FA_RANGE',
            field: 'recoveryCode',
          },
          removeErr: OTPScreen.handleCloseRequired,
        };

        title = <h2>Recovery Code</h2>;
        button = (
          <div className={classes.alignResendButton}>
            <Button
              type="submit"
              className={classes.activeButton}
              disabled={!isValidOtp}
              onClick={this.handleRecoveryCodeSubmit}
            >
              <Trans>BUTTON.VERIFY</Trans>
            </Button>
          </div>
        );

        break;

      case 'verify-securityKey':
        title = (
          <>
            <h2>Verify Through Security Key</h2>
            <p>Login using a registered security key.</p>
          </>
        );

        button = (
          <div className={classes.alignResendButton}>
            <Button
              type="submit"
              className={classes.activeButton}
              disabled={showDeviceList}
              onClick={this.validateU2F}
            >
              <Trans>BUTTON.VERIFY</Trans>
            </Button>
          </div>
        );
        break;

      default:
        title = '';
        button = '';
    }

    return {
      title,
      object,
      button,
    };
  };

  showAnotherMethods = () => {
    const { history } = this.props;
    history.state = { method: this.url };
    history.push('/login-methods');
  };

  /**
   * setInputValue set otp value to state
   * @param e
   */

  setInputValue = (e) => {
    const { inputValue } = this.state;
    // check sms otp is valid or not
    if (e.target.name === 'sms' || e.target.name === 'otp') {
      let otpLength;
      if (e.target.value) otpLength = (e.target.value).length;
      if (otpLength === 6) this.setState({ isValidOtp: true });
      if (otpLength > 6 || otpLength < 6) this.setState({ isValidOtp: false });
    }
    if (e.target.name === 'recoveryCode') {
      let recoveryCodeLength;
      if (e.target.value) recoveryCodeLength = (e.target.value).length;
      if (recoveryCodeLength > 1) this.setState({ isValidOtp: true });
      else this.setState({ isValidOtp: false });
    }

    inputValue[e.target.name] = e.target.value;
    this.setState({ inputValue });
  };

  /**
   * Show list Of U2F if more than one Devices
   */
  validateU2F = () => {
    // If single device than it open model directly
    if (this.deviceList.length) {
      if (this.deviceList.length === 1) {
        this.validateU2FRequest(this.deviceList[0]);
      } else {
        // Else show Devices List
        this.setState({ showDeviceList: true });
      }
    }
  };

  /**
   *  Get the authRequest of particular device
   */
  validateU2FRequest = async (device) => {
    const deviceId = device.id;

    const { history } = this.state;

    try {
      const supported = await isSupported();
      if (supported) {
        const responseObj = await requestAtLogin({
          deviceid: deviceId,
          token: this.token,
        });
        const { authRequest } = responseObj.response.data;
        const authResponse = await sign(authRequest);
        const u2fResponse = {
          authRequest,
          authResponse,
          deviceId,
          token: this.token,
        };
        this.onVerifyAtLogin(u2fResponse);
      } else {
        history.state = {
          status: 'error',
          msg: 'TOASTER.BROWSER_SUPPORT_ERROR',
          show: true,
        };
        this.handleIsU2FModel();
      }
    } catch (error) {
      history.state = {
        status: 'error',
        msg: 'TOASTER.FAILED_DEVICE',
        show: true,
      };
      this.setState({ showDeviceList: true });
      this.handleIsU2FModel();
    }
  };

  onVerifyAtLogin = (u2fResponse) => {
    const { getPermission, history } = this.props;

    verificationAtLogin(u2fResponse).then((res) => {
      if (res.response.userData) {
        sessionStorage.setItem('cred', JSON.stringify(res.response));
        AuthService.authenticate(res.response.token);
        getPermission();
        history.push('/');
      } else {
        history.state = {
          status: 'error',
          msg: 'TOASTER.INVALID_SECURITY_KEY',
          show: true,
        };
      }
      this.handleIsU2FModel();
    }).catch(() => {
      this.clearState();
      history.state = {
        status: 'error',
        msg: 'TOASTER.INVALID_SECURITY_KEY',
        show: true,
      };
      this.handleIsU2FModel();
    });
  };

  onSelectDevice = (id) => {
    this.setState({
      showDeviceList: false,
      isU2FModelOpen: true,
    });
    setTimeout(() => {
      this.validateU2FRequest({ id });
    }, 3000);
  };

  render() {
    const {
      classes,
      location,
      logo,
      changeTheme,
      ...other
    } = this.props;

    const { showDeviceList, otpKey, isU2FModelOpen } = this.state;

    this.url = location.pathname.split('/').join('');

    const {
      title,
      object,
      button,
    } = this.inputValue(classes);

    return (
      <>
        <div className={classes.main}>
          <AppBar position="static" className={classes.header}>
            <Toolbar>
              <img className={classes.headerLogo} src={headerLogo} alt="header logo" />
              <Typography variant="h6" className={classes.title} />
              <Button color="inherit" onClick={changeTheme}>
                {logo ? (
                  <img src={darkLogo} alt="login logo" />
                ) : (
                  <img src={lightLogo} alt="login logo" />
                )}

              </Button>
            </Toolbar>
          </AppBar>
          <Container maxWidth="xl" className={classes.mainLogin}>

            <Grid container spacing={0} style={{ height: '100%' }}>

              <Grid item xs={12} sm={12} md={6} lg={7} className={classes.loginLeft}>

                <Grid container spacing={0}>

                  <Grid item xs={12}>
                    <div className="rightLogo">

                      {logo ? (
                        <img src={dmLogo} alt="login logo" />
                      ) : (
                        <img src={lmLogo} alt="" />
                      )}

                      <div style={{ alignSelf: 'center' }}>
                        <p>
                          Rev
                          <span>Bits</span>
                        </p>
                        <span>SOFTWARE UPDATE PORTAL</span>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} />

                </Grid>

              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={5} style={{ display: 'flex' }} className={classes.loginRight}>
                <form
                  name="otpForm"
                  className={classes.loginForm}
                  noValidate
                  autoComplete="off"
                >
                  <div className={classes.mobileBackgroundImage} />

                  <CustomMessages {...other} />
                  {!showDeviceList ? (
                    <>
                      <Grid container alignItems="flex-end" className={classes.marginBottom}>
                        <Grid container alignItems="flex-end" className={classes.titleAlign}>
                          {title}
                        </Grid>

                        <Grid
                          item
                          className={`${classes.formInput} ${classes.alignLeft} ${classes.otpInputs} ${classes.inputPadLeft}`}
                        >
                          <CTextField
                            className={classes.errMsg}
                            type="text"
                            name={object.name}
                            label={object.label}
                            validateForm={object.validateForm}
                            removeErr={object.removeErr}
                            onChange={this.setInputValue}
                            key={otpKey}
                          />
                        </Grid>

                        <Grid container alignItems="flex-end" className={classes.titleAlign}>
                          <p aria-hidden="true" className={classes.methodsText} onClick={this.showAnotherMethods}>
                            Use another
                            method(s)
                          </p>
                        </Grid>
                      </Grid>
                      {button}
                    </>
                  ) : (
                    <Grid container spacing={1} alignItems="flex-end" className={classes.marginBottom}>
                      <Grid
                        container
                        spacing={1}
                        alignItems="flex-end"
                        className={classes.alignCenter}
                      >
                        <h2>Choose Your Security Key</h2>
                      </Grid>
                      {this.deviceList.map((data) => (
                        <Grid
                          key={data.id}
                          item
                          className={`${classes.formInput} ${classes.alignCenter}`}
                        >
                          <Button
                            className={`${classes.activeButton}`}
                            onClick={this.onSelectDevice.bind(this, data.id)}
                          >
                            {data.devicename}
                          </Button>
                        </Grid>
                      ))}
                    </Grid>
                  )}

                  {/* <Button className={`${classes.btn2}`}>
                                            Resend SMS
                                                   </Button> */}
                </form>

              </Grid>

            </Grid>

          </Container>

          <AppBar className={classes.footer} position="fixed" color="primary">

            <Toolbar>
              <Typography variant="subtitle2" className={classes.title} style={{ textAlign: 'center' }}>
                ©
                {' '}
                {new Date().getFullYear()}
                {' '}
                RevBits Software Update Portal.
                <span>
                  All Rights Reserved.
                </span>
              </Typography>
            </Toolbar>
          </AppBar>
        </div>
        <U2fInserstDeviceModal
          closeModel={this.handleIsU2FModel}
          open={isU2FModelOpen}
          id={otpKey}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  formValues: getFormValues('OTPScreen')(state),
});

const stylesheets = reduxForm({
  form: 'OTPScreen',
  onSubmit,
})(withStyles(styles, { withTheme: true })(OTPScreen));
export default withTranslation()(
  connect(
    mapStateToProps,
  )(stylesheets),
);
